// Boundaries
export const getV2WardUrl =
  "/api/v1/region/:cityId/regions/type/MUNICIPAL_WARD?geoJson=true";

export const getV2PinCodeUrl =
  "/api/v1/region/:cityId/regions/type/PINCODE?geoJson=true";
